import { render, staticRenderFns } from "./InventorySettings.vue?vue&type=template&id=dbceac2e&"
import script from "./InventorySettings.vue?vue&type=script&lang=js&"
export * from "./InventorySettings.vue?vue&type=script&lang=js&"
import style0 from "./InventorySettings.vue?vue&type=style&index=0&id=dbceac2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports